const FileUploadLineProgressBar = ({ percentage }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div
                className="progress"
                style={{
                    flex: 1,
                    height: '4px',
                    backgroundColor: '#2A3A4A',
                    borderRadius: '4px',
                    width: 150,
                }}
            >
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                        width: `${percentage}%`,
                        backgroundColor: '#3871FF',
                        height: '4px',
                        borderRadius: '4px',
                    }}
                    aria-valuenow={percentage}
                    aria-valuemin="0"
                    aria-valuemax="100"
                />
            </div>
        </div>
    )
}

export default FileUploadLineProgressBar